import { render, staticRenderFns } from "./reset_message.vue?vue&type=template&id=1d458627&lang=pug&"
import script from "./reset_message.ts?vue&type=script&lang=ts&"
export * from "./reset_message.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports